import { Router } from '@tanstack/react-router';
import { AxiosInstance, AxiosRequestHeaders, InternalAxiosRequestConfig } from 'axios';

import { TokenManager } from '../../../../auth/TokenManager';

async function injectAuthHeader(config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> {
    const accessToken = await TokenManager.getInstance().getToken();

    if (!accessToken) {
        return config;
    }

    return {
        ...config,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ...config.headers,
        } as AxiosRequestHeaders,
    };
}

const handleAuthorizationError = (router: Router<any, any, any>) => (error: any) => {
    if (error.response?.status !== 401) {
        return Promise.reject(error);
    }

    router.navigate({ to: '/logout' });
    return Promise.reject(error);
};

export function addAuthenticationInterceptors(axios: AxiosInstance, router: Router<any, any, any>) {
    axios.interceptors.request.use(injectAuthHeader);
    axios.interceptors.response.use(null, handleAuthorizationError(router));
}
